/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  LogisticShipmentProps,
  OrderInvoiceProps,
  OrderPaymentProps,
  SaleOrderProps,
} from '@/types'

export const getFormattedPayloadData = (
  initialData: SaleOrderProps,
): Partial<SaleOrderProps> => {
  return {
    uuid: initialData?.uuid,
    shipments: (initialData?.shipments?.map((shipment) => {
      return {
        uuid: shipment?.uuid,
      }
    }) || []) as LogisticShipmentProps[],
    payments: (initialData?.payments?.map((payment) => {
      const data: Record<string, any> = {} as OrderPaymentProps
      Object.keys(payment).forEach((key: string) => {
        const keyAux = key as keyof OrderPaymentProps
        if (payment?.[keyAux] && keyAux !== 'proof') {
          data[keyAux] = payment[keyAux]
        }
      })
      return data
    }) || []) as OrderPaymentProps[],
    invoices: (initialData?.invoices?.map((invoice) => {
      const data: Record<string, any> = {} as OrderInvoiceProps
      Object.keys(invoice).forEach((key: string) => {
        const keyAux = key as keyof OrderInvoiceProps
        if (
          invoice?.[keyAux] &&
          keyAux !== 'xmlFile' &&
          keyAux !== 'pdfFile' &&
          keyAux !== 'deductionXmlFile' &&
          keyAux !== 'deductionPdfFile'
        ) {
          data[keyAux] = invoice[keyAux]
        }
      })
      return data
    }) || []) as OrderInvoiceProps[],
  }
}
